import React from "react";
import { GlobalProvider } from "./context/GlobalContext";

export const wrapRootElement = ({element}) => {

    return <GlobalProvider>{element}</GlobalProvider>
}